export default [
  {
    path: '/my-bill',
    name: 'my-bill',
    meta: { title: '我的财富', auth: true, keepAlive: true, deepth: 1, color: '#FD6404' },
    component: () => import('../../views/wealth/my-bill.vue')
  },
  {
    path: '/my-bill-detail',
    name: 'my-bill-detail',
    meta: { title: '月收益明细', auth: true, keepAlive: true, deepth: 2, color: '#FD6404' },
    component: () => import('../../views/wealth/my-bill-detail.vue')
  }
];
